import React, { useState, useEffect } from 'react';
import MainLayout from "../CommonControlls/MainLayout";
import Topmenu from "../CommonControlls/Topmenubar";
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import axios from 'axios';
import dataArray from "./Util";
import { useHistory } from 'react-router-dom';
import * as Common from "../CommonControlls/CommonJs";
const Edit = () => {
    const [imageData, setImageData] = useState(null);
    const [youtubeVideoUrl, setYoutubeVideoUrl] = useState('');
    const [title, setTitle] = useState('');
    const [validationError, setValidationError] = useState({ title: false, url: false, file: false });
    const [images, setImages] = useState([]);
    const [dataArray1, setDataArray1] = useState({});
    const history = useHistory();

    useEffect(() => {
        setDataArray1(dataArray["Post"]);
        console.log(dataArray1)
    }, []);



    const handleInput = (e) => {
        const { name, value } = e.target;
        setDataArray1(prevState => ({
            ...prevState,
            [name]: value
        }));
    };




    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setImageData(file);
        }
    };



    const handleUrlChange = (event) => {
        setYoutubeVideoUrl(event.target.value);
    };

    const handleTitleChange = (event) => {
        setTitle(event.target.value);
    };

    const clearForm = () => {
        setImageData(null);
        setYoutubeVideoUrl('');
        setTitle('');
        setValidationError({ title: false, url: false, file: false });
    };

    // const handleUpdate = () => {
    //     const { title, youtubeVideoUrl, imageFile } = dataArray1;

    //     if (!title || !imageData) {
    //         // Validation failed
    //         setValidationError({
    //             title: !title,
    //             url: !youtubeVideoUrl,
    //             file: !imageData
    //         });
    //         return;
    //     }

    //     const formData = new FormData();
    //     formData.append('ImageFile', imageFile);
    //     formData.append('YoutubeVideoUrl', youtubeVideoUrl);
    //     formData.append('Title', title);
    //     console.log(imageFile)
    //     console.log(youtubeVideoUrl)
    //     console.log(title)
    //     axios.put(`http://localhost:44484/api/HelpDesk/${dataArray1.id}`, formData, {
    //         headers: {
    //             'Content-Type': 'multipart/form-data',
    //         },
    //     })
    //         .then((response) => {
    //             alert('Request Post successfully');
    //             setImages(response.data || []);
    //             clearForm();
    //         })
    //         .catch((error) => {
    //             console.error('Error uploading image:', error);
    //         });
    // };




    const handleUpdate = () => {
        const { title, youtubeVideoUrl } = dataArray1;
      
        if (!title || !imageData) {
          // Validation failed
          setValidationError({
            title: !title,
            url: !youtubeVideoUrl,
            file: !imageData
          });
          return;
        }
      
        const formData = new FormData();
        formData.append('ImageFile', imageData);
        formData.append('YoutubeVideoUrl', youtubeVideoUrl);
        formData.append('Title', title);
      
        axios.put(Common.APILinks.HelpDesk_Edit+`/${dataArray1.id}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
          .then((response) => {
            alert('Request Update successfully');
            history.push('/HelpDesk');
            setImages(response.data || []);
            clearForm();
          })
          .catch((error) => {
            console.error('Error uploading image:', error);
          });
      };
      
    return (
        <div>
            <MainLayout />
            <div id="right-panel" className="right-panel">
                <Topmenu PageTitle="Help Module" />
                <div class="content">
                    <div class="PageHeader_Container">
                        <h2>Post Help</h2>
                    </div>

                    <div class="card col-md-8 col-lg-8">
                        <div class="card-body row">
                            <Container>
                                <Row>
                                    <Col>
                                        <Form>
                                            <div class="row">
                                                <div class="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                    <label for=""><span style={{ color: "red" }}>* </span>Title</label>
                                                    <input
                                                        autoComplete="off"
                                                        type="text"
                                                        class={`form-control ${validationError.title ? 'is-invalid' : ''}`}
                                                        id="Title"
                                                        placeholder="Enter Title"
                                                        name="title"
                                                        onChange={handleInput}
                                                        value={dataArray1.title}
                                                    />
                                                    {validationError.title && <div className="invalid-feedback">Title is required</div>}
                                                </div>



                                                <div class="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                    <label for=""><span style={{ color: "red" }}>* </span>YoutubeVideoUrl</label>
                                                    <input
                                                        autoComplete="off"
                                                        type="text"
                                                        class={`form-control ${validationError.title ? 'is-invalid' : ''}`}
                                                        id="youtubeVideoUrl"
                                                        placeholder="Enter Title"
                                                        name="youtubeVideoUrl"
                                                        onChange={handleInput}
                                                        value={dataArray1.youtubeVideoUrl}
                                                    />
                                                    {validationError.youtubeVideoUrl && <div className="invalid-feedback">youtubeVideoUrl is required</div>}
                                                </div>


                                                <div class="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                    <label for=""><span style={{ color: "red" }}>*</span>Attachment</label>
                                                    <input
                                                        type="file"
                                                        //  value={dataArray1.imageUrl}
                                                        onChange={handleFileChange}
                                                        class={`form-control-file ${validationError.file ? 'is-invalid' : ''}`}
                                                    />
                                                    {validationError.file && <div className="invalid-feedback">File is required</div>}
                                                </div>
                                                <div class="formInput_Container col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                    <Button variant="primary" style={{ marginTop: '35px' }} onClick={handleUpdate}>
                                                        Save
                                                    </Button></div>

                                            </div>
                                        </Form>
                                    </Col>
                                </Row>
                            </Container>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Edit;
